import React, { useState, useEffect } from "react";
import { FaShoppingCart } from "react-icons/fa";
import axios from "axios";

const ProcurementTable = () => {
  const [items, setItems] = useState([]);
  const [itemQuantities, setItemQuantities] = useState({});
  const [cart, setCart] = useState([]);

  useEffect(() => {
    fetchProcurementItems(); // Call on mount
  }, []);

  const fetchProcurementItems = async () => {
    const vendorId = localStorage.getItem("vendorId");
    const authToken = localStorage.getItem("authToken");

    if (!vendorId || !authToken) {
      alert("Vendor ID or token missing");
      return;
    }

    try {
      const res = await axios.get(
        `https://backend.maamaas.com/food/api/inventory/procurement/vendor/${vendorId}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const data = res.data || [];
      // console.log("Fetched procurement items:", data);

      setItems(data);

      const defaultQuantities = {};
      data.forEach((item) => {
        defaultQuantities[item.itemName] = 1;
      });
      setItemQuantities(defaultQuantities);
    } catch (err) {
      console.error("❌ Error fetching procurement items:", err);
    }
  };

  const incrementQty = (itemName) => {
    setItemQuantities((prev) => ({
      ...prev,
      [itemName]: prev[itemName] + 1,
    }));
  };

  const decrementQty = (itemName) => {
    setItemQuantities((prev) => ({
      ...prev,
      [itemName]: Math.max(1, prev[itemName] - 1),
    }));
  };

  const addToCart = async (item) => {
    const vendorId = localStorage.getItem("vendorId");
    const authToken = localStorage.getItem("authToken");

    if (!vendorId || !authToken) {
      alert("Vendor ID or token missing");
      return;
    }

    const procurementQty = itemQuantities[item.itemName];

    const payload = {
      id: 0, // backend will auto-generate ID
      vendorId: Number(vendorId),
      itemName: item.itemName,
      procurementQuantity: Number(procurementQty),
    };

    try {
      const response = await axios.post(
        `https://backend.maamaas.com/food/api/inventory/cart/add`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      alert(`✅ ${item.itemName} added to cart successfully!`);

      // Optional: update local cart state
      const exists = cart.find((i) => i.itemName === item.itemName);
      if (!exists) {
        setCart([...cart, { ...item, procureQty: procurementQty }]);
      }

    } catch (error) {
      console.error("❌ Error adding to cart:", error?.response?.data || error);
      alert("❌ Failed to add item to cart.");
    }
  };


  const tableHeaderStyle = {
    padding: "12px",
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "#b15cd6",
    color: "white",
  };

  const tableCellStyle = {
    padding: "12px",
    border: "1px solid #ddd",
    textAlign: "center",
  };

  const buttonStyle = {
    padding: "6px 10px",
    margin: "5px",
    backgroundColor: "#b15cd6",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  };

  const qtyButton = {
    padding: "5px 10px",
    margin: "0 5px",
    fontWeight: "bold",
    backgroundColor: "#ddd",
    border: "none",
    cursor: "pointer",
    borderRadius: "4px",
  };

  return (
    <div className="invetory-data">
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",

        }}

      >
        <thead>
          <tr>
            <th style={tableHeaderStyle}>S.No</th>
            <th style={tableHeaderStyle}>Item Name</th>
            <th style={tableHeaderStyle}>Current Qty</th>
            <th style={tableHeaderStyle}>Procure Qty</th>
            <th style={tableHeaderStyle}>Action</th>
          </tr>
        </thead>
        <tbody>
          {items.length === 0 ? (
            <tr>
              <td colSpan="5" style={tableCellStyle}>
                No items found or data is missing.
              </td>
            </tr>
          ) : (
            items.map((item, index) => (
              <tr key={index}>
                <td style={tableCellStyle}>{index + 1}</td>
                <td style={tableCellStyle}>{item.itemName}</td>
                <td style={tableCellStyle}>{item.procurementQuantity}</td>
                <td style={tableCellStyle}>
                  <button style={qtyButton} onClick={() => decrementQty(item.itemName)}>-</button>
                  {itemQuantities[item.itemName]}
                  <button style={qtyButton} onClick={() => incrementQty(item.itemName)}>+</button>
                </td>
                <td style={tableCellStyle}>
                  <button style={buttonStyle} onClick={() => addToCart(item)}>
                    <FaShoppingCart /> Add to Cart
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ProcurementTable;
